<template>
    <el-popover
        placement="bottom-end"
        width="250"
        @show="showPopper"
        trigger="click">
        <span slot="reference" class="el-icon-circle-plus pointer pointer-icon ver-middle"></span>
        <div>
            <p>
                <el-input v-model="search" @input="changeSearchText" clearable placeholder="请输入查询关键字"></el-input>
            </p>
            <div class="list-wrap">
                <el-collapse v-model="collapseVal">
                    <el-collapse-item v-for="item in filterList" :key="item.name"
                                      :title="item.display_name" :name="item.name" v-show="!(isCompare&&(item.name==platName+'_sum_data'))&&!(item.children||[]).every(field=>field.checked||(search&&!field.display_name.toLowerCase().includes(search.toLowerCase())))">
                        <p
                            class="pointer data-item"
                            :class="[getIsHourField(field)||field.checked||(search&&!field.display_name.toLowerCase().includes(search.toLowerCase()))?'is-hide':'']"
                            :title="field.display_name"
                            v-for="field in (item.children||[])"
                            :key="field.name"
                            @click="checkField(field)">
                            <template v-if="field.config.title">
                                <span>{{field.display_name}}</span>
                                <el-tooltip class="item" effect="dark" :content="field.config.title" placement="top">
                                    <i class="el-icon-question pointer ml4 text-color-normal" ></i>
                                </el-tooltip>
                            </template>
                            <span v-else>{{field.display_name}}</span>
                        </p>
                        <p v-if="(item.children||[]).every(field=>getIsHourField(field)||field.checked||(search&&!field.display_name.toLowerCase().includes(search.toLowerCase())))" class="tac text-color-gray">暂无数据</p>
                    </el-collapse-item>
                </el-collapse>
                <p v-if="filterList.length<=0" class="tac text-color-gray">暂无数据</p>
                <p v-if="filterList.every(item=>((item.children||[]).every(field=>field.checked||(search&&!field.display_name.toLowerCase().includes(search.toLowerCase())))))" class="tac text-color-gray">暂无数据</p>

            </div>
        </div>
    </el-popover>
</template>

<script>
    export default {
        name: "FilterActionPop",
        props:{
            type:String,
            dataList:Array,
            isTimeFilter:{
                required: false,
                type:Boolean,
                default:false,
            },
            isCompare:{
                required: false,
                type:Boolean,
                default:false,
            },
            platName:{
                required: false,
                type:String,
                default:'',
            }
        },
        data(){
            return {
                search:'',
                collapseVal:[],
                // filterList:[],
            }
        },
        computed:{
            filterList(){
                return this.dataList;
            },
        },
        methods:{
            showPopper(){
                this.collapseVal = this.dataList.map(item=>item.name);
            },
            changeSearchText(val){
                console.log('changeSearchText',val);
            },
            checkField(field){
                console.log('checkField',field);
                this.$emit('check',field)
            },
            getIsHourField(field){
                if(this.isTimeFilter){
                    let config = field.config||{};
                    return !(config.time_type||[]).includes('hour');
                }else{
                    return false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pointer-icon{
        font-size: 18px;
    }
    .pointer-icon:hover{
        color: #409EFF;
    }
    .list-wrap{
        max-height: 300px;
        overflow-y: auto;
        padding: 5px 2px;
    }

    ::v-deep .list-wrap .el-collapse {
        padding-bottom: 30px;
        border-bottom: none;
    }

    ::v-deep .list-wrap .el-collapse-item__header {
        height: 32px;
        line-height: 32px;
        font-weight: bold;
        font-size: 12px;
    }

    ::v-deep .list-wrap .el-collapse-item .el-collapse-item__content {
        padding-bottom: 10px;
        font-size: 12px;
    }

    ::v-deep .list-wrap .el-collapse-item:last-child .el-collapse-item__wrap {
        border-bottom: none;
    }

    .data-item{
        padding-left: 10px;
        line-height: 22px;
        &:hover{
            background-color: #e8eaec;
        }
    }
    .is-hide{
        display: none;
    }
</style>
